import Ajv from 'ajv';
import {isError, attempt} from 'lodash';

const ajv = new Ajv({allErrors: true, verbose: true});

const messages = {
  CUSTOM_TEMPLATE: (message, state) => {
    if (!isError(attempt(JSON.parse, message.payload.json))) {
      state.dispatch('initCustomTemplate', message.payload.json);
    } else {
      throw 'Cannot parse template JSON';
    }
  },
  EXTERNAL_ERROR: (message, state) => {
    state.commit('setError', {
      message: {
        data: message.payload.messages.map(e => {
          return {propertyName: e.messageLabel, propertyValue: e.messageValue};
        })
      }
    });
  },
  EXTERNAL_INFO: (message, state) => {
    state.commit('setInfo', {
      message: {
        data: message.payload.messages.map(e => {
          return {propertyName: e.messageLabel, propertyValue: e.messageValue};
        })
      }
    });
  }
};

const messageSchema = {
  type: 'object',
  required: ['status', 'payload'],
  properties: {
    status: {type: 'string', enum: Object.keys(messages)}
  },
  allOf: [
    {
      if: {
        properties: {status: {const: 'CUSTOM_TEMPLATE'}}
      },
      then: {
        properties: {
          payload: {
            type: 'object',
            required: ['json'],
            properties: {
              json: {type: 'string'}
            }
          }
        }
      }
    },
    {
      if: {
        properties: {
          status: {oneOf: [{const: 'EXTERNAL_ERROR'}, {const: 'EXTERNAL_INFO'}]}
        }
      },
      then: {
        properties: {
          payload: {
            type: 'object',
            required: ['messages'],
            properties: {
              messages: {
                type: 'array',
                items: {
                  type: 'object',
                  required: ['messageValue'],
                  properties: {
                    messageLabel: {type: 'string'},
                    messageValue: {type: 'string'}
                  }
                }
              }
            }
          }
        }
      }
    }
  ]
};

const validate = (message, process, messageService) => {
  const valid = ajv.validate(messageSchema, message);
  if (valid) {
    try {
      return process(message);
    } catch (e) {
      messageService.post({status: 'ERROR', payload: {errorMessage: e}});
    }
  } else {
    messageService.post({
      status: 'ERROR',
      payload: {errorMessage: ajv.errors.map(e => e.message).join(', ')}
    });
  }
};

const buildProcessor = state => {
  return message => {
    messages[message.status](message, state);
  };
};

export default (state, messageService) => {
  return {
    handle: message => {
      validate(message, buildProcessor(state), messageService);
    }
  };
};
